export enum MessageType {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Entered = 'ENTERED',
  Left = 'LEFT',
  MovedRoom = 'MOVED',
  SameRoom = 'SAME',
  Chat = 'CHAT',
  Whisper = 'WHISPER',
  Shout = 'SHOUT',
  Emote = 'EMOTE',
  Dance = 'DANCE',
  Mod = 'MOD',
  Error = 'ERROR',
  Command = 'COMMAND',
  Caption = 'CAPTION'
}
